import UserButton from './UserButton.view';

export { UserButton };
export default UserButton;
